import { handleActions } from 'redux-actions';
import actions from '../actions/notificationActions';
import { initialState } from '../initial-state';

export default handleActions(
  {
    [actions.AddNotificationHistory]: (state, action) => {
      const historyItem = action.payload;
      const currentHistory = state.history || [];
      
      const updatedHistory =
        currentHistory.length < 15
          ? [...currentHistory, historyItem]
          : [...currentHistory.slice(1), historyItem];

      return {
        ...state,
        history: updatedHistory,
      };
    },

    [actions.UpdateUnread]: (state, action) => {
      return {
        ...state,
        unread: action.payload.unread,
      };
    },

    [actions.UpdateNumberOfNotifs]: (state, action) => {
      return {
        ...state,
        numberOfNotifications: action.payload.numberOfNotifications,
      };
    },

    [actions.UpdateImageLoad]: (state, action) => {
      return {
        ...state,
        imageLoad: action.payload.imageLoad,
      };
    },
  },
  initialState.NotificationHistory
);
